import {Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import {faPlus} from '@fortawesome/free-solid-svg-icons';
import {environment} from '../../../../../../../environments/environment';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {UserService} from '../../../../../../shared/services/user/user.service';
import {ProjectService} from '../../../../../../shared/services/project/project.service';
import {StatesService} from '../../../../../../shared/services/state/states.service';
import {ToastrService} from 'ngx-toastr';
import {TranslateService} from '@ngx-translate/core';
import {ProjectUser} from '../../../../../../shared/classes/project-user/project-user';
import {Subject, Subscription} from 'rxjs';
import {UsersConstants} from '../../../../../../shared/constants/users.constants';
import ROLES = UsersConstants.ROLES;

@Component({
    selector: 'app-project-alarms-user-add-list',
    templateUrl: './project-alarms-user-add-list.component.html',
    styleUrls: ['./project-alarms-user-add-list.component.css']
})
export class ProjectAlarmsUserAddListComponent implements OnInit, OnDestroy {

    public displayedColumns: string[] = ['email', 'firstname', 'lastname', 'phone', 'action'];
    public users: MatTableDataSource<any>;
    public faPlus = faPlus;
    public showSpinner: boolean = false;
    @Input('alarmUsersList') alarmUsersList: any[] = [];
    @Input('validatorMode') validatorMode : boolean = false;
    public pageSizeOptions = environment.pageSizeOptions;
    public pageSize = environment.pageSize;

    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;

    private reloadList: Subscription;

    constructor(public activeModal: NgbActiveModal,
                private userService: UserService,
                private projectService: ProjectService,
                private statesService: StatesService,
                private toastr: ToastrService,
                private translate: TranslateService,) {
    }

    ngOnInit() {
        this.reloadList = this.statesService.reloadListUser.subscribe(() => {
            this.initUsers();
        });
        this.initUsers();
    }

    ngOnDestroy(): void {
        this.reloadList.unsubscribe();
    }

    addUserToAlarm(user: any) {
        this.alarmUsersList.push(user);
        let usersIdList: any[] = [];
        this.alarmUsersList.forEach(user => {
            user.send_email = user.send_email === undefined ? false : user.send_email;
            user.send_sms = user.send_sms === undefined ? false : user.send_sms;
            user.send_voice = user.send_voice === undefined ? false : user.send_voice;
            usersIdList.push(user.id);
        });
        let userTemp: any[] = [];
        this.users.data.forEach(d => {
            if (!usersIdList.includes(d.id)) {

                userTemp.push(d);
            }
        });
        this.users.data = userTemp;
        this.statesService.reloadProjectAlarmsUserRemove.next();
    }

    applyFilter(filterValue: string) {
        filterValue = filterValue.trim();
        filterValue = filterValue.toLowerCase();
        this.users.filter = filterValue;
    }

    private initUsers() {
        this.showSpinner = true;
        let usersIdList: any[] = [];
        this.alarmUsersList.forEach(user => {
            user.send_email = user.send_email === undefined ? false : user.send_email;
            user.send_sms = user.send_sms === undefined ? false : user.send_sms;
            user.send_voice = user.send_voice === undefined ? false : user.send_voice;
            usersIdList.push(user.id);
        });
        let role : string =  !this.validatorMode ? '' : ROLES.ROLE_ALARM_VALIDATOR;
        this.userService.getUsers(this.statesService.stateLevel, true, role, true)
            .subscribe(
                (data: any) => {

                    let userTemp: any[] = [];
                    data.forEach(d => {
                        if (!usersIdList.includes(d.id)) {

                            userTemp.push(d);
                        }
                    });
                    this.users = new MatTableDataSource(userTemp);
                    this.users.filter = null;
                    this.users.sort = this.sort;
                    this.users.paginator = this.paginator;
                    this.showSpinner = false;
                }
                ,
                error2 => {
                    this.showSpinner = false;

                }
            );
    }


}
